import React, { useEffect, useState } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { createProperty, getPropertyById, updateProperty } from "../../../services/propertyService";
import { convertToFormData } from "../../../Utils/convertToFormData";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { API_BASE_URL } from "../../../Utils/constants";
import useCustomNavigate from "../../../hooks/useCustomNavigate";

const EditProperty = () => {

  const {goTo} = useCustomNavigate()

  const { propertyId } = useParams();
  const { data, loading, error:fetchingError } = useFetch(
      () => getPropertyById(propertyId),
      [propertyId]
  );

  console.log("datadata",data);
  
  // State for loading and error
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");


  const [formData, setFormData] = useState({
    title: "",
    price: "",
    propertyType: "",
    status: "",
    area: "",
    bedrooms: "",
    bathrooms: "",
    developer: "",
    project: "",
    transactionType: "",
    furnishedStatus: "",
    carParking: "",
    perSqftRate: "",
    flatType: "", // New Field for Flat Type (BHK)
    floor: { current: "", total: "" },
    emi: { available: false, perMonth: "" },
    moreDetails: {
      priceBreakup: "",
      BookingAmount: "",
      Address: "",
      description: "",
      furnishing: "",
      Flooring: "",
      Type_of_Ownership: "",
      Overlooking: "",
      Age_of_Construction: "",
      Additional_Rooms: "",
      reraId: "",
      waterAvailability: "",
      statusOfElectricity: "",
      floorsAllowedForConstruction: "",
      liftCount: "",
    },
    amenities: {
      swimmingPool: false,
      gym: false,
      powerBackup: false,
      parking: false,
      garden: false,
    },
    images: [],
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;


    if (name === "project" && value !== "Custom") {
      // Reset customProject if project is not "Custom"
      setFormData((prevState) => ({
        ...prevState,
        project: value,
        customProject: "", // Clear customProject
      }));
    }
    else if (type === "checkbox" && name.startsWith("amenities")) {
      const amenity = name.split(".")[1];
      setFormData((prevState) => ({
        ...prevState,
        amenities: { ...prevState.amenities, [amenity]: checked },
      }));
    } else if (name.includes(".")) {
      const [section, key] = name.split(".");
      setFormData((prevState) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [key]: value,
        },
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).map((file) => ({
      file: file, // Original file
      url: URL.createObjectURL(file), // File URL for preview
    }));

    setFormData((prevState) => ({
      ...prevState,
      images: [...prevState.images, ...files], // Append new files
    }));
  };

  const handleRemoveImage = (indexToRemove) => {
    setFormData((prevState) => ({
      ...prevState,
      images: prevState.images.filter((_, index) => index !== indexToRemove),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading
    setError(""); // Clear previous errors


    const payload = new FormData();
    // Append basic fields
    payload.append('title', formData.title);
    payload.append('price', formData.price);
    payload.append('propertyType', formData.propertyType);
    payload.append('status', formData.status);
    payload.append('area', formData.area);
    payload.append('sqftPrice', formData.perSqftRate);
    payload.append('bedrooms', formData.bedrooms);
    payload.append('bathrooms', formData.bathrooms);
    payload.append('developer', formData.developer);


    // Append project or customProject
    if (formData.project === "Custom") {
      payload.append("project", formData.customProject);
    } else {
      payload.append("project", formData.project);
    }


    payload.append('transactionType', formData.transactionType);
    payload.append('furnishedStatus', formData.furnishedStatus);
    payload.append('carParking', formData.carParking);
    payload.append("flatType", formData.flatType); // Append Flat Type (BHK)

    // Append nested objects (e.g., floor, emi, moreDetails)
    payload.append('floor', JSON.stringify(formData.floor));
    payload.append('emi', JSON.stringify(formData.emi));
    payload.append('moreDetails', JSON.stringify(formData.moreDetails));
    payload.append('amenities', JSON.stringify(formData.amenities));

    // Append images
    formData?.images?.forEach((image) => {
      if(image.file){
        payload.append("images", image.file);
      }
    });


    // Append the `postedBy` field
    const userId = "677d1bd9980535da5a002840"; // Replace with actual user ID from context/state
    payload.append('postedBy', userId);


    const keyMapping = {
      title: "property_title",
      price: "property_price",
      "moreDetails": "property_details", // Rename for API if needed
      images: "property_images",
    };

    // Specify keys to stringify
    const nestedKeysToStringify = ["moreDetails"];

    const payload2 = convertToFormData(formData, keyMapping, nestedKeysToStringify);



    try {
      const response = await updateProperty(propertyId,payload); // Call the API
      if (response.success) {
        goTo("/profile")
        alert("Property successfully updated!");
      } else {
        setError("Failed to add property. Please try again.");
      }
    } catch (err) {
      console.error("Error adding property:", err);
      setError("An error occurred while adding the property. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading
    }

    console.log("Submitted Property Data:", formData);
  };



  useEffect(() => {
    if (data) {
      setFormData({
        ...data,
        perSqftRate: data?.sqftPrice,
        images: data?.images?.map((item) =>
          item?.fileUrl ? { fileUrl: `${API_BASE_URL}${item?.fileUrl}` } : {}
        ),
        emi: typeof data?.emi === "string" ? JSON.parse(data.emi) : data?.emi || {},
        floor: typeof data?.floor === "string" ? JSON.parse(data.floor) : data?.floor || {},
        moreDetails: typeof data?.moreDetails === "string" ? JSON.parse(data.moreDetails) : data?.moreDetails || {},
        amenities: typeof data?.amenities === "string" ? JSON.parse(data.amenities) : data?.amenities || {},
      });
    }
  }, [data]);
  


  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-md pt-[140px]">
      <h2 className="text-2xl font-bold mb-6">Edit Property</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Section 1: Basic Details */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Basic Details</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Flat Type (BHK)</label>
              <input
                type="text"
                name="flatType"
                value={formData.flatType}
                onChange={handleChange}
                placeholder="e.g., 2 BHK, 3 BHK"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Price</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Property Type</label>
              <select
                name="propertyType"
                value={formData.propertyType}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="House">House</option>
                <option value="Apartment">Apartment</option>
                <option value="Condo">Condo</option>
                <option value="Land">Land</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Transaction Type</label>
              <select
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="New Property">New Property</option>
                <option value="Resale">Resale</option>
                <option value="Rental">Rental</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="For Sale">For Sale</option>
                <option value="For Rent">For Rent</option>
                <option value="Under Construction">Under Construction</option>
                <option value="Sold">Sold</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Furnished Status</label>
              <select
                name="furnishedStatus"
                value={formData.furnishedStatus}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="Fully Furnished">Fully Furnished</option>
                <option value="Semi-Furnished">Semi Furnished</option>
                <option value="Unfurnished">Unfurnished</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Car Parking</label>
              <select
                name="carParking"
                value={formData.carParking}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="1 Covered">1 Covered</option>
                <option value="2 Covered">2 Covered</option>
                <option value="Open Parking">Open Parking</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Project</label>
              <select
                name="project"
                value={formData.project}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select Project</option>
                <option value="Project A">Project A</option>
                <option value="Project B">Project B</option>
                <option value="Project C">Project C</option>
                <option value="Custom">Custom</option>
              </select>
              {/* Custom Project Input */}
              {formData.project === "Custom" && (
                <input
                  type="text"
                  name="customProject"
                  value={formData.customProject || ""}
                  onChange={(e) =>
                    setFormData((prevState) => ({
                      ...prevState,
                      customProject: e.target.value,
                    }))
                  }
                  placeholder="Enter Custom Project Name"
                  className="mt-2 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              )}
            </div>

            {/* EMI Section */}
            <div>
              <label className="block text-sm font-medium text-gray-700">EMI Available</label>
              <div className="flex items-center gap-2 mt-1">
                <input
                  type="checkbox"
                  name="emi.available"
                  checked={formData.emi.available}
                  onChange={(e) =>
                    setFormData((prevState) => ({
                      ...prevState,
                      emi: { ...prevState.emi, available: e.target.checked },
                    }))
                  }
                />
                <label>Yes</label>
              </div>
              {formData.emi.available && (
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700">Per Month</label>
                  <input
                    type="text"
                    name="emi.perMonth"
                    value={formData.emi.perMonth}
                    onChange={(e) =>
                      setFormData((prevState) => ({
                        ...prevState,
                        emi: { ...prevState.emi, perMonth: e.target.value },
                      }))
                    }
                    placeholder="e.g., 21,000"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
              )}
            </div>

          </div>
        </fieldset>

        {/* Section 2: Property Details */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Property Details</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Area (sqft)</label>
              <input
                type="number"
                name="area"
                value={formData.area}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Per Square Feet Rate</label>
              <input
                type="text"
                name="perSqftRate"
                value={formData.perSqftRate}
                onChange={handleChange}
                placeholder="e.g., 3,932/sqft"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Bedrooms</label>
              <input
                type="number"
                name="bedrooms"
                value={formData.bedrooms}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Bathrooms</label>
              <input
                type="number"
                name="bathrooms"
                value={formData.bathrooms}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Developer</label>
              <input
                type="text"
                name="developer"
                value={formData.developer}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>


            <div>
              <label className="block text-sm font-medium text-gray-700">Floor</label>
              <input
                type="text"
                name="floor.current"
                value={formData.floor.current}
                onChange={handleChange}
                placeholder="Current Floor (e.g., 4)"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
              <input
                type="text"
                name="floor.total"
                value={formData.floor.total}
                onChange={handleChange}
                placeholder="Total Floors (e.g., 9)"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 mt-2"
              />
            </div>
          </div>
        </fieldset>

        {/* Section 2: Additional Rooms & Age of Construction */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Property Features</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Additional Rooms</label>
              <select
                name="moreDetails.Additional_Rooms"
                value={formData.moreDetails.Additional_Rooms}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="1 Store Room">1 Store Room</option>
                <option value="Study">Study</option>
                <option value="Store">Store</option>
                <option value="Servant Room">Servant Room</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Age of Construction</label>
              <select
                name="moreDetails.Age_of_Construction"
                value={formData.moreDetails.Age_of_Construction}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="New Construction">New Construction</option>
                <option value="1-5 Years">1-5 Years</option>
                <option value="5-10 Years">5-10 Years</option>
                <option value="10-20 Years">10-20 Years</option>
                <option value="Above 20 Years">Above 20 Years</option>
              </select>
            </div>
          </div>
        </fieldset>


        {/* Section 3: Additional Details */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Additional Details</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Price Breakup</label>
              <input
                type="number"
                name="moreDetails.priceBreakup"
                value={formData.moreDetails.priceBreakup}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Booking Amount</label>
              <input
                type="number"
                name="moreDetails.BookingAmount"
                value={formData.moreDetails.BookingAmount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>


            {/* Flooring */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Flooring</label>
              <select
                name="moreDetails.Flooring"
                value={formData.moreDetails.Flooring}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="Marble">Marble</option>
                <option value="Tile">Tile</option>
                <option value="Wooden">Wooden</option>
              </select>
            </div>

            {/* Overlooking */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Overlooking</label>
              <select
                name="moreDetails.Overlooking"
                value={formData.moreDetails.Overlooking}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="Garden/Park">Garden/Park</option>
                <option value="Pool">Pool</option>
                <option value="Main Road">Main Road</option>
              </select>
            </div>

            {/* Water Availability */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Water Availability</label>
              <select
                name="moreDetails.waterAvailability"
                value={formData.moreDetails.waterAvailability}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="24 Hours Available">24 Hours Available</option>
                <option value="Limited Supply">Limited Supply</option>
              </select>
            </div>

            {/* Electricity Status */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Electricity Status</label>
              <select
                name="moreDetails.statusOfElectricity"
                value={formData.moreDetails.statusOfElectricity}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="No Powercut">No Powercut</option>
                <option value="Rare Powercut">Rare Powercut</option>
              </select>
            </div>

            {/* Floors Allowed for Construction */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Floors Allowed for Construction
              </label>
              <input
                type="number"
                name="moreDetails.floorsAllowedForConstruction"
                value={formData.moreDetails.floorsAllowedForConstruction}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>

            {/* Lift Count */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Lift Count</label>
              <input
                type="number"
                name="moreDetails.liftCount"
                value={formData.moreDetails.liftCount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>




            <div>
              <label className="block text-sm font-medium text-gray-700">Address</label>
              <textarea
                name="moreDetails.Address"
                value={formData.moreDetails.Address}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            </div>



            <div>
              <label className="block text-sm font-medium text-gray-700">Type of Ownership</label>
              <select
                name="moreDetails.Type_of_Ownership"
                value={formData.moreDetails.Type_of_Ownership}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="">Select</option>
                <option value="Freehold">Freehold</option>
                <option value="Leasehold">Leasehold</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Description</label>
              <textarea
                name="moreDetails.description"
                value={formData.moreDetails.description}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                placeholder="Add a description of the property"
              ></textarea>
            </div>
          </div>
        </fieldset>

        {/* Section 4: Upload Images */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Upload Images</legend>
          <div>
            <input
              type="file"
              name="images"
              multiple
              onChange={handleImageChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
            />
            <div className="flex flex-wrap gap-4 mt-4">
              {formData?.images?.map((image, index) => (
                <div key={index} className="relative w-24 h-24">
                  <img
                    src={image.url || image.fileUrl} // Use the URL for preview
                    alt={`Property ${index}`}
                    className="object-cover w-full h-full rounded-md"
                  />
                  <IoCloseCircle
                    className="absolute top-0 right-0 text-red-600 text-2xl cursor-pointer"
                    onClick={() => handleRemoveImage(index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </fieldset>



        {/* Section 3: Amenities */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Amenities</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="amenities.swimmingPool"
                  checked={formData.amenities.swimmingPool}
                  onChange={handleChange}
                />
                Swimming Pool
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="amenities.gym"
                  checked={formData.amenities.gym}
                  onChange={handleChange}
                />
                Gym
              </label>
            </div>
            <div>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="amenities.powerBackup"
                  checked={formData.amenities.powerBackup}
                  onChange={handleChange}
                />
                Power Backup
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="amenities.parking"
                  checked={formData.amenities.parking}
                  onChange={handleChange}
                />
                Parking
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="amenities.garden"
                  checked={formData.amenities.garden}
                  onChange={handleChange}
                />
                Garden
              </label>
            </div>
          </div>
        </fieldset>



        {/* Error Message */}
        {error && <div className="text-red-600 text-sm mt-2">{error}</div>}


        {/* Submit and Cancel Buttons */}
        <div className="mt-6 flex justify-end gap-4">
          <button
            type="button"
            className="bg-gray-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-gray-600"
            onClick={() => console.log("Cancel clicked")}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`bg-blue-600 text-white py-2 px-6 rounded-md shadow-sm hover:bg-blue-700 ${isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}

            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProperty;
